import { showAlert } from "components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import Cargando from "components/Varios/Cargando";
import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { ObtenerInformacionGeneral } from "../Aprobacion Solicitudes/ServicesDirectivoSolicitudes";
import { AprobarSolicitudesHEDTO, InfGenerDirectivoSolicHEDTO } from "../Aprobacion Solicitudes/TypesAprobacionHE";
import TablaHistorialSolicitudesDUHE from "./TablaHistorialSolicitudesHE";
import MonthDatePicker from "components/Varios/DatePicker/MonthDatePicker";
import { ObtenerHistorial } from "./ServicesHistorialSolicitudesHE";
import { ObtenerUltimaFechaMesAnterior } from "functions/DatesFunctions";
import { GetNumberFormatHE } from "components/Admin/Horas Extras/Proyeccion Horas Extras/TablaUnidadesProyeccionHE";

export default function HistorialSolciitudesDUHE() {

    const [loading, setloading] = useState(false);
    const [informacion, setinformacion] = useState<AprobarSolicitudesHEDTO[]>([])
    const [isAprobada, setisAprobada] = useState<boolean | undefined>(undefined);
    const [fechames, setfechames] = useState<Date | null>(null);

    //funcino para obtener indormacion
    async function ObtenerDatosGenerales(fecha: Date, estados: string) {
        setloading(true)
        const mensajeErrorDefault = "No ha sido posible obtener información de las solicitudes";
        const respuesta = await ObtenerHistorial(fecha, estados);
        if (respuesta.status === 200 && respuesta.dataResponse && typeof (respuesta.dataResponse) !== "string") {
            setinformacion(respuesta.dataResponse);
        }
        else if (respuesta.status === 200 && respuesta.dataResponse && typeof (respuesta.dataResponse) === "string") {
            showAlert(respuesta.dataResponse, false);
        }
        else if (respuesta.status === 409) {
            showAlert(respuesta.errorMessage ?? mensajeErrorDefault, false)
        }
        else {
            showAlert(mensajeErrorDefault, false);
        }
        setloading(false)
    }

    function alCambiar(e: any) {
        var valor = e.target.value
        if (valor) {
            valor = +valor;
        }
        if (valor == 1) {
            setisAprobada(true);
        }
        else if (valor == 0) {
            setisAprobada(false);
        }
    }

    useEffect(() => {

        if (fechames !== null && isAprobada !== undefined) {
            const estados = isAprobada ? "AP" : "NE"
            ObtenerDatosGenerales(fechames, estados);
        }

    }, [fechames, isAprobada])


    useEffect(() => {
        // const fecha = ObtenerUltimaFechaMesAnterior();
        const hoy = new Date();
        const fecha = new Date(hoy.getFullYear(), (hoy.getMonth()+1), 0);
        setfechames(fecha)
        setisAprobada(true)
    }, [])

    const valorDevengado = informacion.reduce((acc, curr) => {
        return acc + ((curr.tvhorasextras ?? 0));
    }, 0);

    return (
        <div className='content'>
            <div style={{ alignContent: 'center' }} className="titulo_seccion"> HISTORIAL SOLICITUDES </div>
            <br></br>
            {
                loading && <Cargando />
            }
            {
                !loading &&
                <>
                    <label> Seleccione mes y año:</label>
                    <Row className="d-flex justify-content-start">
                        <Col xl={2}>
                            <MonthDatePicker
                                value={fechames}
                                color="blue"
                                placeholderText="Seleccione fecha"
                                onChange={(e) => setfechames(e)}
                            />
                        </Col>
                        {fechames != null &&
                            <Col xl={2}>
                                <select
                                    value={isAprobada ? 1 : 0}
                                    onChange={(e) => alCambiar(e)}
                                    style={{ borderRadius: "5px", borderColor: "#517ED3", padding: '5px 18px' }}
                                >

                                    <option value={1}> Solicitudes Aprobadas </option>
                                    <option value={0}> Solicitudes Negadas </option>
                                </select>
                            </Col>
                        }
                        {fechames && informacion && isAprobada !== undefined && (
                            <Col xl={3}>
                                <div className="d-flex justify-content-center"
                                    style={{
                                        border: ' 1px solid #243165',
                                        borderRadius: '5px',
                                        color: '#243165',
                                        padding: '5px 5px',
                                        //minHeight: '40px',
                                        //lineHeight: '1.4',
                                        textAlign: 'center'
                                    }}
                                >
                                    Presupuesto Devengado Mensual:  {GetNumberFormatHE(valorDevengado)}
                                </div>
                            </Col>
                        )}
                    </Row>
                    <br></br>
                    {fechames && informacion && isAprobada !== undefined && (
                        <>
                            <TablaHistorialSolicitudesDUHE
                                informacionContenido={informacion}
                                loading={loading}
                                isAprobada={isAprobada}
                            />
                        </>
                    )}
                </>
            }
        </div>
    )
}